import type { MultiSelectOption } from "@volca/ui/components/ui/multi-select";
import { AP_ASSIGNEE_ME } from "@/accounts-payable/ap-url-state";
import {
  AP_ACTION_TYPE,
  AP_UNASSIGNED,
  type ApActionType,
  type ApAssignee,
} from "@/accounts-payable/types";
import { actionTypeMeta } from "@/accounts-payable/utils";

const ACTION_FILTER_ORDER: ApActionType[] = [
  AP_ACTION_TYPE.flagForReview,
  AP_ACTION_TYPE.matchJob,
  AP_ACTION_TYPE.markNonJob,
  AP_ACTION_TYPE.linkVendor,
  AP_ACTION_TYPE.mergeVendor,
  AP_ACTION_TYPE.createPo,
  AP_ACTION_TYPE.updatePo,
  AP_ACTION_TYPE.createReceipt,
  AP_ACTION_TYPE.replaceReceipt,
  AP_ACTION_TYPE.cancelReceipt,
  AP_ACTION_TYPE.createReturn,
  AP_ACTION_TYPE.createPricebookItem,
  AP_ACTION_TYPE.updatePricebookCost,
  AP_ACTION_TYPE.createQboBill,
  AP_ACTION_TYPE.updateQboBill,
  AP_ACTION_TYPE.noAction,
];

const QUICKBOOKS_ACTION_TYPES: ApActionType[] = [
  AP_ACTION_TYPE.createQboBill,
  AP_ACTION_TYPE.updateQboBill,
];

export const actionFilterOptions = (
  hasQuickbooks: boolean,
  selected: readonly ApActionType[] = [],
): MultiSelectOption[] =>
  ACTION_FILTER_ORDER.filter(
    (type) =>
      hasQuickbooks ||
      !QUICKBOOKS_ACTION_TYPES.includes(type) ||
      selected.includes(type),
  ).map((type) => ({ id: type, name: actionTypeMeta(type).label }));

export const assigneeFilterOptions = (
  people: ApAssignee[],
  currentUserId: string | null | undefined,
): MultiSelectOption[] => [
  { id: AP_ASSIGNEE_ME, name: "Me" },
  { id: AP_UNASSIGNED, name: "Unassigned" },
  ...people
    .filter((person) => person.id !== currentUserId)
    .map(({ id, name }) => ({ id, name })),
];

export const shownAssigneeTokens = (
  tokens: string[],
  people: ApAssignee[],
  currentUserId: string | null | undefined,
) =>
  tokens
    .map((token) => (token === currentUserId ? AP_ASSIGNEE_ME : token))
    .filter(
      (token, index, all) =>
        all.indexOf(token) === index &&
        (token === AP_ASSIGNEE_ME ||
          token === AP_UNASSIGNED ||
          people.some((person) => person.id === token)),
    );

export const unmatchedAssigneeOptions = (
  tokens: string[],
  options: MultiSelectOption[],
  currentUserId: string | null | undefined,
  loading: boolean,
): MultiSelectOption[] =>
  tokens
    .filter((token) => !options.some((option) => option.id === token))
    .map((id) => ({
      id,
      name:
        id === currentUserId ? "Me" : loading ? "Loading…" : "Unknown person",
    }));
